<template>
  <el-dialog title="试卷详情" :visible.sync="dialogVizible" custom-class="form-dialog" width="70%"
    :close-on-click-modal="false" @close='closeExportDialog()'>
    <div class="d-flex flex-justify-end" v-if="!isPreview">
      <el-button type="primary" @click="exportPapers()">导出</el-button>
    </div>
    <div id="pdfDom">
      <div class="exam-detail-header d-flex flex-justify-between" v-if="!isPreview">
        <div class="e-d-l">
          <el-form size="small" label-width="150px" class="user-search">
            <el-form-item label="姓名："> {{ details.userName }}</el-form-item>
            <el-form-item label="考试编码："> {{ details.examCode }} </el-form-item>
            <el-form-item label="考试名称："> {{ details.examName }} </el-form-item>
            <el-form-item label="考试开始时间："> {{ details.examStartTime }}</el-form-item>
            <el-form-item label="考试结束时间："> {{ details.examEndTime }}</el-form-item>
          </el-form>
        </div>
        <div class="e-d-r d-flex ">
          <div>
            <p>{{ details.examScore }}<span>分</span></p>
            <img src="@/assets/img/fenshuxian.png" alt="">
          </div>
          <img class="fenzu" src="@/assets/img/fenzu.png" alt="">

        </div>
      </div>
      <div class="exam-content">
        <div class="exam-card mg-tp10" v-for="(item, index) in questionContent" :key="item.questionId">
          <div class="e-c-header d-flex flex-justify-between">
            <div class="d-flex flex-align-center">
              <template v-if="!isPreview">
                <i class="el-icon-success col-0f0 mg-rgt5 fz20" v-if="item.answerCorrect"></i>
                <i class="el-icon-error col-f41 mg-rgt5 fz20" v-else></i>
              </template>

              问题{{ index + 1 }}
            </div>
            <span>分值：{{ item.questionScore }}</span>
          </div>
          <div class="e-c-main">
            <div>{{ index + 1 }}、{{ item.questionTopic }}</div>
            <div class="mg-tp10" v-if="item.questionImg">
              <img :src="item.questionImg" style="width: 200px;" alt="" srcset="">
            </div>

            <div class="mg-tp10">
              <template v-if="item.questionType == 1">
                <el-radio-group v-model="item.myAnswer" disabled class="d-flex flex-column ">
                  <el-radio v-for="(value, key) of item.questionOption" :key="key" :label="key">
                    {{ key }}、
                    {{ value
                    }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-else-if="item.questionType == 2">
                <el-checkbox-group v-model="item.myAnswer" disabled class="d-flex flex-column ">
                  <el-checkbox v-for="(value, key) of item.questionOption" :key="key" :label="key">
                    {{ key }}、
                    {{ value
                    }}
                  </el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-else>
                <el-radio-group v-model="item.myAnswer" disabled>
                  <el-radio-button :label="true">正确</el-radio-button>
                  <el-radio-button :label="false">错误</el-radio-button>
                </el-radio-group>
              </template>
            </div>
            <div class="mg-tp20">
              答案：<span class="col-0f0 mg-rgt5">
                <template v-if="item.questionType === 3">
                  {{ JSON.parse(item.questionAnswer) ? '正确' : '错误' }}
                </template>
                <template v-else>
                  {{ item.questionAnswer }}
                </template>
              </span>
              <template v-if="!isPreview">
                我的选择：{{ getAnswer(item) }}
              </template>

            </div>
            <div class="mg-tp20" v-if="!isPreview">
              | 题目解析
              <div class="mg-tp10">
                {{ item.questionAnalysis }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getPdf } from '@/utils/exportPDF';

export default {
  props: {
    examId: String,
    visible: Boolean,
    isPreview: Boolean,
    detailFn: { type: Function }

  },
  watch: {
    visible (val) {
      this.dialogVizible = val;
      if (val) {
        this.detailFn().then(res => {
          this.details = res.data;
          if (res.data.answerResDetailList && res.data.answerResDetailList.length) {
            res.data.answerResDetailList.forEach(el => {
              if (el.questionType == 2) {
                el.myAnswer = el.myAnswer ? el.myAnswer.split(',') : [];
              }
            })
          }
          this.questionContent = res.data.questionContent || res.data.answerResDetailList || [];
        });

      }
    }
  },
  data () {
    return {
      dialogVizible: this.visible,
      checkList: [],
      radio: '',
      radio1: '',
      details: {},
      questionContent: []
    }
  },
  methods: {

    getAnswer (item) {
      if (item.questionType == 2) {
        return item.myAnswer ? item.myAnswer.join(',') : []
      } else if (item.questionType == 3) {
        if (item.myAnswer !== null) {
          return JSON.parse(item.myAnswer) ? '正确' : '错误'

        } else {
          return '-'
        }
      } else {
        return item.myAnswer
      }
    },
    closeExportDialog () {
      this.$emit('close')
    },
    exportPapers () {
      getPdf('pdfDom', '试卷详情');
    },
  }
}
</script>

<style lang="scss" scoped>
.exam-detail-header {
  background: #f0f2f5;
  border: 1px solid #ddd;
  margin-top: 5px;

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }

  .e-d-l {
    width: 70%;
    border-right: 1px solid rgb(221, 221, 221);
  }

  .e-d-r {
    width: 30%;
    justify-content: space-around;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        font-size: 30px;
        padding: 0;
        margin: 0;

        span {
          margin-left: 5px;
          font-size: 14px;
        }
      }
    }

    img {
      width: 140px;

    }

    .fenzu {
      width: 50px;
      height: fit-content;
    }
  }
}

.exam-content {
  width: 85%;
  margin: 0 auto;

  .exam-card {
    border: 1px solid #ddd;

    .e-c-header {
      width: 100%;
      background: #fafafb;
      height: 40px;
      border-bottom: 1px solid #ddd;
      line-height: 40px;
      padding-left: 15px;
      box-sizing: border-box;

      span {
        width: 150px;
      }
    }

    .e-c-main {
      padding: 20px 30px 20px 10px;
      box-sizing: border-box;
      line-height: 18px;
    }
  }
}
</style>

<style>
.e-c-main .el-radio__label,
.e-c-main .el-checkbox__label {
  white-space: normal;
}

.e-c-main .el-checkbox {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/previewPapers.vue